import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showConfirmationPopupAction } from './actions';

export const useConfirmationPopup = () => {
    const dispatch = useDispatch();

    return useCallback(
        popupData => dispatch(showConfirmationPopupAction(popupData)),
        [dispatch]
    );
};
